const PageActionsNavbar = ({ children, actions = null }) => (
  <nav className="w-full flex justify-between items-center min-h-[45px]">
    <div className="flex gap-2 items-center text-sm">{children}</div>
    {actions ? <div className="flex gap-2 items-center">{actions}</div> : null}
  </nav>
);

export default PageActionsNavbar;
